export const APP_NAME = 'fabrik';
export const APPS_BASE_DOMAIN = 'integrtr.io';
export const BUILDER_BASE_DOMAIN = 'integrtr.com';
export const LOGIN_METHOD_KEY = '__integrtr_dataflow_login_method';

/** Rows requested per page for datasource-backed lists when no limit is configured. */
export const DEFAULT_LIST_PAGE_SIZE = 50;

export const SESSION_INFO_COOKIE_NAMES = {
  LOCAL: 'sessionInfo_local',
  DEV: 'sessionInfo_dev',
  STAGING: 'sessionInfo_staging',
  SANDBOX: 'sessionInfo_sandbox',
  PROD: 'sessionInfo_prod',
  EXPT: 'sessionInfo_experiment',
} as const;
export const PLATFORM_API_PREFIX = 'platform';
export const PLATFORM_API_SUFFIX = 'api';
